import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {getReportDetails} from '../api/tripline';

@Component({
  selector: 'app-mange-travel',
  templateUrl: './mange-travel.component.html',
  styleUrls: ['./mange-travel.component.css']
})
export class MangeTravelComponent implements OnInit {

  constructor() { }

  data=[]
  back=[]
  days = {
    sunday: 'الأحد',
    monday: 'الإثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
  };
  loader=true
  selectedPoints={students:[]}
  ngOnInit() {
    this.getData()
  }


  setPoint(travel,way){
    this.selectedPoints=travel['students'][way]?travel['students'][way]:{students:[]}
  }
  async getData(){

let result=await getReportDetails()
    this.loader=true

if(result){
  this.data=result.data.data.filter(travel=>travel.way=='go')
  this.back=result.data.data.filter(travel=>travel.way=='back')
  this.loader=false

}

  }
  @ViewChild("search")
  public searchElementRef: ElementRef;

  removeSearch() {
    this.searchElementRef.nativeElement.value=""
  }
}
